import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ILineChartData } from '../../models';
import { Status } from './status';

class StatusDisplayController implements angular.IComponentController {
    conditions: any[];
    statuses: any[];
    hovered: ILineChartData;
    clicked: ILineChartData;
    hoveredStatus: Status;

    private _selectedStatus: Status;
    private _currentStatuses: Status[] = [];
    private _infoIds = [8, 9];
    private _warningIds = [2, 3, 5, 7, 10];
    private _dangerIds = [1, -1, -2, 4, 6, 11];

    static $inject = [];

    constructor() {
        this.conditions = [
            {
                classed: 'progress-bar-warning',
                condition: (d) => d >= 5 && d < 20
            }, {
                classed: 'progress-bar-danger',
                condition: (d) => d >= 20
            }
        ];
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj.statuses && changesObj.statuses.currentValue) {
            this._currentStatuses = changesObj.statuses.currentValue;
            this.clicked = this.checkSelectedStatus(this._currentStatuses, this._selectedStatus, this.clicked);
        }
    }

    mouseenter(status) {
        this.hovered = {
            data: status.inputValues ? status.inputValues : [],
            classed: this.statusClass(status)
        };
        this.hoveredStatus = status;
    }

    mouseleave() {
        this.hovered = {
            data: [],
            classed: this.statusClass(this.hoveredStatus)
        };
        this.hoveredStatus = null;
    }

    click(status) {
        let values = [];
        const classed = this.statusClass(status);

        // Set new status and values
        if (this.isSelected(status)) {
            this._selectedStatus = null;
        } else {
            this._selectedStatus = status;
            if (status.inputValues) {
                values = status.inputValues;
            }
        }

        // Set new clicked value
        this.clicked = this.getClicked(values, classed, !!this._selectedStatus);
    }

    getClicked(values: any[], classed: string, isSelected: boolean): ILineChartData {
        return {
            data: values,
            classed: classed,
            isSelected: isSelected
        };
    }

    checkSelectedStatus(currentStatuses: Status[], selectedStatus: Status, clicked: ILineChartData): ILineChartData {
        if (currentStatuses && currentStatuses.length > 0 && selectedStatus) {
            clicked = this.getClicked([], '', false);
            if (selectedStatus) {
                const found = _.find(currentStatuses, s => s.statusId === selectedStatus.statusId);
                if (found) {
                    clicked = this.getClicked(found.inputValues, this.statusClass(found), true);
                }
            }
        }
        return clicked;
    }

    getClass(status) {
        let result = 'progress-bar-success';
        if (this._warningIds.indexOf(status.statusId) >= 0) {
            result = 'progress-bar-warning';
        } else if (this._dangerIds.indexOf(status.statusId) >= 0) {
            result = 'progress-bar-danger';
        } else if (this._infoIds.indexOf(status.statusId) >= 0) {
            result = 'progress-bar-info';
        }
        return result;
    }

    isSelected(status: Status) {
        if (status.percentage > 0) {
            return status === this._selectedStatus;
        } else {
            return false;
        }
    }


    private statusClass(status: Status): string {
        return status ? status.name.replace(/ /g, '').toLowerCase() : '';
    }
}

export const wtStatusDisplay: ComponentDefinition = {
    componentId: 'wtStatusDisplay',
    controller: StatusDisplayController,
    template: require('./statusDisplay.component.html'),
    controllerAs: 'vm',
    bindings: {
        statuses: '<',
        hovered: '=?',
        clicked: '=?'
    }
};
